export var userNamePassword = "Please enter necessary fields to proceed.";


/** WEBPACK FOOTER **
 ** ./src/validationMessages.js
 **/